import React from "react";
import {
  Autocomplete as AutoCompleteMUI,
  CircularProgress,
  TextField,
  createFilterOptions,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

const filterOptions = createFilterOptions({
  matchFrom: "start",
  limit: 50,
});

const AutoCompleteMultiple = ({
  name,
  rules,
  label,
  optionId = "id",
  optionLabel = "label",
  options = [],
  size = "small",
  isLoading,
  sx,
}) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => {
        const { onChange, value = [], ref } = field;
        return (
          <AutoCompleteMUI
            multiple
            filterOptions={filterOptions}
            value={
              value
                ? options.filter((option) =>
                    value.some((item) => {
                      if (typeof item === 'object') {
                        return item[optionId] === option[optionId];
                      }
                      return item === option[optionId];
                    })
                  )
                : []
            }
            getOptionLabel={(option) => {
              return option[optionLabel] || '';
            }}
            isOptionEqualToValue={(option, value) => {
              if (typeof value === 'object') {
                return option[optionId] === value[optionId];
              }
              return option[optionId] === value;
            }}
            onChange={(event, values) => {
              onChange(values ? values : []);
            }}
            size={size}
            options={options}
            loading={isLoading}
            sx={sx}
            renderInput={(params) => (
              <TextField
                {...params}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {isLoading ? <CircularProgress size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
                label={label}
                error={!!error}
                helperText={error?.message}
                inputRef={ref}
              />
            )}
          />
        );
      }}
    />
  );
};

export { AutoCompleteMultiple };